export default {
  MULTIPLE_EMAILS: /^([A-Z0-9.%+-]+@[A-Z0-9.-]+.[A-Z]{2,6})*([,][s]*([A-Z0-9.%+-]+@[A-Z0-9.-]+.[A-Z]{2,6}))*$/i,
  REGEX_NUMBER: /^[0-9\b]+$/i,
  REGEX_CHARACTER: /^[a-zA-Z0-9]+$/i,
  REGEX_CHARACTER_WITH_SPACE: /^[a-zA-Z0-9\s]+$/i,
};
